import {BaseDocument} from "./BaseDocument";
import {EntityField} from "../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../core/genericdocuments/EntityFieldDataType";
import {LookupEntities} from "../../core/genericdocuments/ReferenceDetails";
import UsersService from "../../services/UsersService";
import {User} from "../../models/User";

export const baseDocumentFields: IntercateKeysMap<BaseDocument, EntityField<BaseDocument>> = {
	indexingNumber: {
		name: "indexingNumber", dataType: EntityFieldDataType._string, label: "Delovodni broj",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
	indexingDate: {
		name: "indexingDate", dataType: EntityFieldDataType._date, label: "Datum zavođenja",
		validator: { required: true, maxDate: new Date() },
		sortable: true,
		filterable: true
	},
	documentNumber: {
		name: "documentNumber", dataType: EntityFieldDataType._string, label: "Broj dokumenta",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
	documentDate: {
		name: "documentDate", dataType: EntityFieldDataType._date, label: "Datum dokumenta",
		validator: { required: true, maxDate: new Date() },
		sortable: true,
		filterable: true
	},
	sectorId: {
		name: "sectorId", dataType: EntityFieldDataType._reference, label: "Sektor",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Departments
		},
		// filterOptions: (formState, options, lookupData) => {
		// 	console.log(formState)
		// 	console.log(options)
		// 	console.log(lookupData(LookupEntities.Users))
		// },
		validator: { required: true },
		sortable: true
	},
	assignedTo: {
		name: "assignedTo", dataType: EntityFieldDataType._reference, label: "Dodeljeno korisniku",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Users
		},
		filterOptions: (formState, options, lookupData) => {
			console.log(formState)
			console.log(options)
			console.log(lookupData(LookupEntities.Users))
			const userOptions = lookupData(LookupEntities.Users)
			const filteredOptions = []
			for (let userOption of userOptions) {
				let user = userOption.data
				if (formState && UsersService.userHasAnyRightInSector(user, formState.sectorId)) {
					filteredOptions.push({label: `${user.firstName} ${user.lastName}`, value: user.id, data: user})
				}
			}
			return filteredOptions
		},
		validator: { required: false },
		sortable: true
	},
	visibleTo: {
		name: "visibleTo", dataType: EntityFieldDataType._string, label: "Visible only to",
		referenceDetails: {
			lookupOptions: null,
			lookupEntities: [LookupEntities.Users, LookupEntities.Departments, LookupEntities.Positions]
		},
		validator: { required: true },
		sortable: true
	},
	tags: {
		name: "tags", dataType: EntityFieldDataType._chips, label: "Tagovi",
		validator: { required: false },
		sortable: false,
		filterable: true
	},
	description: {
		name: "description", dataType: EntityFieldDataType._string, label: "Napomena"
	},
};
